<template>
  <div>
    <div class="navBox">
      <div @click="linkTo('about-us')">公司介绍</div>
      <div @click="linkTo('cooperative-partner')">合作伙伴</div>
      <!-- <div>加入我们</div> -->
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    linkTo(val) {
      this.$router.push({
        name: val,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navBox {
  width: 24rem;
  display: flex;
  justify-content: space-around;
  margin-top: 5.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/MobileAboutNav.vue